/*
 * @Description: file content
 * @Author:
 * @Date: 2023-08-22 11:43:42
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-11-20 19:04:05
 */
import { ss } from '@/utils/storage'

import defaultAvatar from '@/assets/default-avatar.png'

import type { UserExtraInfo } from '@/types/user'

const LOCAL_NAME = 'userStorage'

export interface UserInfo {
  /**
   * 用户id
   */
  id: number
  avatar?: string
  headerImg?: string
  phone: string
  userKey: string
  /**
   * 使用能量点
   */
  balance?: number
  nickName: string
  /**
   * 注册时间
   */
  createTime: string
  /**
   * 我的邀请码（是用户唯一、不变的邀请码，每个用户的邀请码都是唯一的）
   */
  code: string
  /**
   * 能量点到期数量
   */
  expirationAmount: number
  /**
   * 能量点到期时间
   */
  expirationTime: number
  /**
   * 是否显示能量点提醒
   */
  showRemind: Boolean
  /**
   * 推荐模式-选择偏好主营品类
   */
  mainCategoryList: string[] | null
  /**
   * 数美链商户后台用户标志 0：无权限 1：有权限
   */
  smlBgUserFlag: 0 | 1
  token: string
  /** 是否跳过完善信息白名单, 1是白名单直接跳过完善信息 */
  skipCompleteWhitelist: number
  name: string
}

export interface DropMenuInfo {
  balance: number
  expiringSoonAmount?: number
  enterpriseAmount: {
    accountType: number
    enterpriseId: number
    enterpriseName: string
    role: number
    balance: number
    archiveCount?: number
  }[]
}

export interface UserState {
  userInfo: UserInfo
  dropMenuInfo: DropMenuInfo
  userExtraInfo: UserExtraInfo
}

export function defaultSetting(): UserState {
  return {
    userInfo: {
      id: -1,
      avatar: defaultAvatar,
      headerImg: defaultAvatar,
      userKey: '',
      phone: '',
      balance: 0, // 使用能量点
      nickName: '',
      createTime: '',
      code: '',
      // description: 'Star on <a href="https://github.com/Chanzhaoyu/chatgpt-bot" class="text-blue-500" target="_blank" >Github</a>',
      expirationAmount: 0,
      expirationTime: 0,
      showRemind: false, // 是否显示能量点提醒
      mainCategoryList: null,
      skipCompleteWhitelist: 0, // 是否跳过完善信息白名单, 1是白名单
      name: '',
    },
    dropMenuInfo: {
      balance: -1,
      enterpriseAmount: [],
    },
    userExtraInfo: {
      /**
       * 公司名称
       */
      companyName: '',
      /**
       * 公司类型
       */
      companyTypeList: [],
      /**
       * 所属城市ID
       */
      locCity: null,
      /**
       * 用户名称
       */
      name: '',
      /**
       * 其他公司类型
       */
      otherCompanyType: '',
      /**
       * 其他职位类型
       */
      otherPositionType: '',
      /**
       * 职位类型
       */
      positionType: null,
    },
  }
}

export function getLocalState(): UserState {
  const localSetting: UserState | undefined = ss.get(LOCAL_NAME)

  return { ...defaultSetting(), ...localSetting }
}

export function setLocalState(setting: UserState): void {
  ss.set(LOCAL_NAME, setting)
}
